"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base = _interopRequireWildcard(require("./_base"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Palette composition: colorName: the main color shade colorName_1 ->
 * colorName_4 : shades for the color 1 is the lightest, 4 the darkest 1 & 2 are
 * lighter shades 3 & 4 darker shades the base colorName shade would be in the
 * middle.
 *
 * The exception are the "dark" and "light" color neutrals for these 2 palettes
 * the base color falls at the end of the spectrum.
 *
 * It is recommended that dark text is used over shades 1 & 2
 * and light text over shades 3 & 4.
 */
var palette = {
  green: "#14AD7D",
  green_1: "#D0EFE5",
  // shade lightest
  green_2: "#72CEB1",
  // shade light
  green_3: "#09875F",
  // shade darker
  green_4: "#224E53",
  // shade darkest

  dark: "#222222",
  //   (HS)L 13.3 (darkest)
  dark_1: "#8F9098",
  // (HS)L 56.5
  dark_2: "#71727A",
  // (HS)L 39.2
  dark_3: "#494A50",
  // (HS)L 27.8
  dark_4: "#2F3036",
  // (HS)L 19.6

  light: "#FFFFFF",
  //   (HS)L 100 (lightest)
  light_1: "#F2F4FA",
  // (HS)L 98
  light_2: "#E8E9F1",
  // (HS)L 92.9
  light_3: "#D4D6DD",
  // (HS)L 87.1
  light_4: "#C5C6CC",
  // (HS)L 73.7

  yellow: "#FFB12A",
  yellow_1: "#FFF7E9",
  // shade lightest
  yellow_2: "#FFD07F",
  // shade lighter
  yellow_3: "#F3A51E",
  // shade darker
  yellow_4: "#E3841C",
  // shade darkest

  red: "#F44B16",
  red_1: "#FDDBD0",
  // shade lightest
  red_2: "#F89373",
  // shade lighter
  red_3: "#D74010",
  // shade darker
  red_4: "#BF3206",
  // shade darkest

  azure: "#575FCC",
  azure_1: "#BCBFEB",
  // shade lightest
  azure_2: "#797FD6",
  // shade lighter
  azure_3: "#4E56C5",
  // shade darker
  azure_4: "#464CA3" // shade darkest
};

var fontSizes = _objectSpread(_objectSpread({}, _base["default"].fontSizes), {}, {
  xs: "10px"
});
var fontWeights = _objectSpread(_objectSpread({}, _base["default"].fontWeights), {}, {
  bold: 600
});
var borderRadius = {
  none: "0px",
  xs: "2px",
  s: "4px",
  base: "6px",
  m: "8px",
  l: "10px",
  xl: "12px",
  xxl: "20px"
};
var iconSizes = {
  xxs: "10px",
  xs: "12px",
  s: "14px",
  base: "16px",
  m: "18px",
  l: "24px",
  xl: "32px",
  inherit: "inherit"
};
var fields = _objectSpread(_objectSpread({}, _base["default"].fields), {}, {
  inputVariant: "border",
  searchVariant: "filled",
  radioCheckIconSize: iconSizes.l,
  checkBorderRadius: borderRadius.base
});
var buttons = _objectSpread(_objectSpread({}, _base["default"].buttons), {}, {
  secondary: {
    variant: "border",
    color: "border",
    textColor: "textSecondary"
  },
  tertiary: {
    variant: "filled",
    color: "textTertiary",
    textColor: "text"
  },
  danger: {
    variant: "filled",
    color: "error",
    textColor: "backgroundPrimary"
  }
});
var colors = _objectSpread(_objectSpread({}, _base.baseColorTokens), {}, {
  primary: palette.azure,
  primary_1: palette.azure_1,
  // shade lightest
  primary_2: palette.azure_2,
  // shade light
  primary_3: palette.azure_3,
  // shade darker
  primary_4: palette.azure_4,
  // shade darkest

  success: palette.green,
  success_1: palette.green_1,
  // shade lightest
  success_2: palette.green_2,
  // shade light
  success_3: palette.green_3,
  // shade darker
  success_4: palette.green_4,
  // shade darkest

  warning: palette.yellow,
  warning_1: palette.yellow_1,
  // shade lightest
  warning_2: palette.yellow_2,
  // shade light
  warning_3: palette.yellow_3,
  // shade darker
  warning_4: palette.yellow_4,
  // shade darkest

  error: palette.red,
  error_1: palette.red_1,
  // shade lightest
  error_2: palette.red_2,
  // shade light
  error_3: palette.red_3,
  // shade darker
  error_4: palette.red_4,
  // shade darkest

  /** UI tokens */
  border: palette.light_2,
  // the most predominant background color: page, card, tab panel
  backgroundPrimary: palette.light,
  // hover color for rows of backgroundPrimary, side tabs buttons, inline notifications
  backgroundSecondary: palette.light_1,
  // alternate rows, footer background
  backgroundTertiary: palette.light_2,
  // tags background, hover over row with backgroundTertiary
  backgroundFourth: palette.light_3,
  // the base text color
  text: palette.dark,
  // text in disabled inputs, timestamp in List
  textSecondary: palette.dark_2,
  // disabled tabs, disabled text
  textTertiary: palette.light_4,
  // text over dark backgrounds
  textInverted: palette.light,
  radioCheckBackground: palette.dark,
  inputBackground: palette.light_2,
  inputButton: palette.dark,
  inputIcon: palette.dark_1,
  inputBorder: palette.light_4,
  // color of labels; not textSecondary because in other themes it might have
  // another color
  label: palette.dark_2,
  avatars: ["#575FCC", "#7E57C2", "#19CA96", "#DF6400", "#3177ED", "#2AB4CA", "#F04378", "#F04343"],
  focus: palette.azure,
  // Colors "palette" should be used directly ONLY IF THERE ISN'T A TOKEN that
  // is better suited for that color. NEVER USE palette colors in Smalt
  // components as they are theme specific and might be missing in some themes.
  palette: _objectSpread({}, palette)
});
var theme = _objectSpread(_objectSpread({}, _base["default"]), {}, {
  borderRadius: borderRadius,
  fields: fields,
  buttons: buttons,
  colors: colors,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  iconSizes: iconSizes
});
var _default = theme;
exports["default"] = _default;